/* ============================================================
   INKHAUS THEME JS  v2
   Cart Drawer · Predictive Search · Mobile Menu · Sticky ATC
   ============================================================ */
(function () {
  'use strict';

  /* ── Helpers ──────────────────────────────────────────── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function money(cents) {
    var fmt = (window.Inkhaus && window.Inkhaus.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.floor(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, ms);
    };
  }

  /* ── Cart API ─────────────────────────────────────────── */
  var CartAPI = {
    get: function () {
      return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); });
    },
    change: function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); });
    },
    add: function (id, qty, properties) {
      var item = { id: id, quantity: qty || 1 };
      if (properties) item.properties = properties;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Error'); });
        return r.json();
      });
    }
  };

  /* ── Cart Count Badge ─────────────────────────────────── */
  function updateCartBadge(count) {
    var badge = document.getElementById('ikh-hdr-cart-count');
    var countEl = document.getElementById('ikh-cd-count');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
    if (countEl) {
      countEl.textContent = count + ' item' + (count !== 1 ? 's' : '');
    }
  }

  /* ── Cart Drawer ──────────────────────────────────────── */
  var CartDrawer = {
    el: null,
    overlay: null,
    body: null,
    footer: null,
    isOpen: false,

    init: function () {
      var self = this;
      this.el      = document.getElementById('ikh-cart-drawer');
      this.overlay = document.getElementById('ikh-overlay');
      this.body    = document.getElementById('ikh-cd-body');
      this.footer  = document.getElementById('ikh-cd-footer');
      if (!this.el) return;

      /* Close button */
      var closeBtn = document.getElementById('ikh-cart-close');
      if (closeBtn) closeBtn.addEventListener('click', function () { self.close(); });

      /* Overlay click */
      if (this.overlay) this.overlay.addEventListener('click', function () { self.close(); });

      /* ESC key */
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.isOpen) self.close();
      });

      /* Cart trigger buttons */
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-cart-trigger]');
        if (!trigger) return;
        e.preventDefault();
        if (self.isOpen) { self.close(); } else { self.open(); }
      });

      /* Init badge */
      CartAPI.get().then(function (cart) {
        updateCartBadge(cart.item_count);
        if (self.body) self._renderBody(cart);
      }).catch(function () {});
    },

    open: function () {
      if (this.isOpen) return;
      this.isOpen = true;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      if (this.overlay) this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var stickyBar = document.getElementById('ikh2-bar');
      if (stickyBar) stickyBar.setAttribute('aria-hidden', 'true');
      this._load();
    },

    close: function () {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      if (this.overlay) this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      var stickyBar = document.getElementById('ikh2-bar');
      if (stickyBar) stickyBar.removeAttribute('aria-hidden');
    },

    _load: function () {
      var self = this;
      if (this.body) this.body.innerHTML = '<div class="ikh-cd__loading"><div class="ikh-cd__spinner"></div></div>';
      if (this.footer) this.footer.hidden = true;
      CartAPI.get().then(function (cart) {
        self._renderBody(cart);
        updateCartBadge(cart.item_count);
      }).catch(function () {
        if (self.body) self.body.innerHTML = '<p class="ikh-cd__err">Could not load cart — please refresh.</p>';
      });
    },

    _renderBody: function (cart) {
      if (!this.body) return;
      if (!cart.items || cart.items.length === 0) {
        this.body.innerHTML = this._emptyHTML();
        if (this.footer) this.footer.hidden = true;
        return;
      }
      var html = '';
      cart.items.forEach(function (item) {
        html += CartDrawer._itemHTML(item);
      });
      this.body.innerHTML = html;
      if (this.footer) {
        this.footer.innerHTML = CartDrawer._footerHTML(cart);
        this.footer.hidden = false;
      }
      this._bindEvents();
    },

    _itemHTML: function (item) {
      var imgSrc = item.featured_image && item.featured_image.url
        ? item.featured_image.url.replace(/(\.\w{3,4})(\?.*)?$/, '_120x120$1')
        : (item.image ? item.image.replace(/(\.\w+)$/, '_120x120$1') : '');
      var img = imgSrc
        ? '<img class="ikh-cd-item__img" src="' + imgSrc + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '" width="80" height="80" loading="lazy">'
        : '<div class="ikh-cd-item__img ikh-cd-item__img--placeholder"></div>';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<span class="ikh-cd-item__variant">' + item.variant_title + '</span>'
        : '';
      var unitPrice = money(item.final_line_price / item.quantity);
      return (
        '<div class="ikh-cd-item" data-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="ikh-cd-item__img-link">' + img + '</a>' +
          '<div class="ikh-cd-item__body">' +
            '<a href="' + item.url + '" class="ikh-cd-item__title">' + item.product_title + '</a>' +
            variant +
            '<div class="ikh-cd-item__row">' +
              '<div class="ikh-cd-item__stepper">' +
                '<button class="ikh-cd-item__step" data-action="dec" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease">−</button>' +
                '<span class="ikh-cd-item__qty">' + item.quantity + '</span>' +
                '<button class="ikh-cd-item__step" data-action="inc" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase">+</button>' +
              '</div>' +
              '<div class="ikh-cd-item__prices">' +
                '<span class="ikh-cd-item__price">' + money(item.final_line_price) + '</span>' +
                (item.quantity > 1 ? '<span class="ikh-cd-item__unit">' + unitPrice + ' ea</span>' : '') +
              '</div>' +
            '</div>' +
          '</div>' +
          '<button class="ikh-cd-item__remove" data-key="' + item.key + '" aria-label="Remove ' + (item.product_title || '').replace(/"/g, '&quot;') + '">' +
            '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M9 3L3 9M3 3l6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>'
      );
    },

    _footerHTML: function (cart) {
      var freeShipping = cart.total_price >= 5000;
      var remaining = 5000 - cart.total_price;
      var shippingNote = freeShipping
        ? '<span class="ikh-cd-footer__ship-ok">✓ Free shipping applied</span>'
        : '<span class="ikh-cd-footer__ship-note">Add ' + money(remaining) + ' more for free shipping</span>';
      return (
        '<div class="ikh-cd-footer__subtotal">' +
          '<span class="ikh-cd-footer__label">Subtotal</span>' +
          '<span class="ikh-cd-footer__total">' + money(cart.total_price) + '</span>' +
        '</div>' +
        '<div class="ikh-cd-footer__ship">' + shippingNote + '</div>' +
        '<a href="/checkout" class="ikh-cd-footer__checkout">Checkout →</a>' +
        '<a href="/cart" class="ikh-cd-footer__view-cart">View full cart</a>'
      );
    },

    _emptyHTML: function () {
      return (
        '<div class="ikh-cd__empty">' +
          '<svg class="ikh-cd__empty-icon" viewBox="0 0 48 48" fill="none">' +
            '<path d="M6 6h3.5l1.5 4m0 0 4 16h18l4-16H11z" stroke="#e2e0dc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<circle cx="18" cy="38" r="2.5" stroke="#e2e0dc" stroke-width="2"/>' +
            '<circle cx="32" cy="38" r="2.5" stroke="#e2e0dc" stroke-width="2"/>' +
          '</svg>' +
          '<p class="ikh-cd__empty-title">Your cart is empty</p>' +
          '<p class="ikh-cd__empty-sub">Add a tee to get started</p>' +
          '<a href="/collections/all" class="ikh-cd__empty-btn">Shop all tees</a>' +
        '</div>'
      );
    },

    _bindEvents: function () {
      var self = this;
      qsa('.ikh-cd-item__step', this.body).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.dataset.key;
          var qty = parseInt(btn.dataset.qty);
          var newQty = btn.dataset.action === 'inc' ? qty + 1 : Math.max(0, qty - 1);

          /* Optimistic UI */
          var item = btn.closest('.ikh-cd-item');
          if (item) {
            var qtyEl = qs('.ikh-cd-item__qty', item);
            if (qtyEl) qtyEl.textContent = newQty;
            if (newQty === 0) { item.style.opacity = '0.4'; item.style.pointerEvents = 'none'; }
            qsa('.ikh-cd-item__step', item).forEach(function (b) { b.dataset.qty = newQty; });
          }

          CartAPI.change(key, newQty).then(function (cart) {
            self._renderBody(cart);
            updateCartBadge(cart.item_count);
          });
        });
      });

      qsa('.ikh-cd-item__remove', this.body).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.dataset.key;
          var item = btn.closest('.ikh-cd-item');
          if (item) { item.style.opacity = '0.4'; item.style.pointerEvents = 'none'; }
          CartAPI.change(key, 0).then(function (cart) {
            self._renderBody(cart);
            updateCartBadge(cart.item_count);
          });
        });
      });
    }
  };

  /* ── Add To Cart (intercept form submits on PDP) ──────── */
  var AddToCart = {
    _spinner: '<svg class="ikh-btn-spin" viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="7" stroke="currentColor" stroke-width="2" stroke-dasharray="32" stroke-dashoffset="12" stroke-linecap="round"/></svg>',

    _setLoading: function (btn, origHTML) {
      btn.disabled = true;
      btn.dataset.origHtml = origHTML;
      btn.classList.add('ikh-btn--loading');
      btn.innerHTML = this._spinner;
    },

    _setDone: function (btn) {
      btn.classList.remove('ikh-btn--loading');
      btn.classList.add('ikh-btn--done');
      btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2 7l4 4 6-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    },

    _resetBtn: function (btn) {
      btn.disabled = false;
      btn.classList.remove('ikh-btn--loading', 'ikh-btn--done');
      btn.innerHTML = btn.dataset.origHtml || 'Add to Cart';
    },

    init: function () {
      var self = this;
      document.addEventListener('submit', function (e) {
        var form = e.target.closest('form[action*="/cart/add"], #ikh-pdp-form');
        if (!form) return;
        e.preventDefault();

        var btn = qs('button[type="submit"]', form) || qs('.ikh-pdp__atc', form);
        var origHTML = btn ? btn.innerHTML : '';
        if (btn) self._setLoading(btn, origHTML);

        var varId = (qs('[name="id"]', form) || {}).value;
        var qty   = parseInt((qs('[name="quantity"]', form) || {}).value) || 1;

        CartAPI.add(varId, qty).then(function () {
          if (btn) self._setDone(btn);
          CartDrawer.open();
          CartAPI.get().then(function (cart) { updateCartBadge(cart.item_count); });
          setTimeout(function () {
            if (btn) self._resetBtn(btn);
          }, 2000);
        }).catch(function (err) {
          if (btn) self._resetBtn(btn);
          alert(err.message || 'Could not add to cart');
        });
      });
    }
  };

  /* ── Predictive Search ────────────────────────────────── */
  var Search = {
    overlay: null,
    input: null,
    results: null,
    spinner: null,
    closeBtn: null,
    isOpen: false,
    _xhr: null,

    init: function () {
      var self = this;
      this.overlay  = document.getElementById('ikh-search-overlay');
      this.input    = document.getElementById('ikh-search-input');
      this.results  = document.getElementById('ikh-search-results');
      this.spinner  = document.getElementById('ikh-search-spinner');
      this.closeBtn = document.getElementById('ikh-search-close');
      if (!this.overlay) return;

      /* Trigger */
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-search-trigger]')) {
          e.preventDefault();
          self.open();
        }
      });

      /* Close button */
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', function () { self.close(); });
      }

      /* Click outside */
      this.overlay.addEventListener('click', function (e) {
        if (e.target === self.overlay) self.close();
      });

      /* ESC */
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.isOpen) self.close();
      });

      /* Input — real-time search */
      if (this.input) {
        this.input.addEventListener('input', debounce(function () {
          var q = self.input.value.trim();
          if (q.length < 2) {
            self._clearResults();
            return;
          }
          self._fetch(q);
        }, 280));

        /* Enter → full search page */
        this.input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            var q = self.input.value.trim();
            if (q) window.location.href = '/search?type=product&q=' + encodeURIComponent(q);
          }
        });
      }
    },

    open: function () {
      if (this.isOpen) { this.close(); return; }
      this.isOpen = true;
      this.overlay.classList.add('is-open');
      this.overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (this.input) setTimeout(function () { Search.input.focus(); }, 80);
    },

    close: function () {
      this.isOpen = false;
      this.overlay.classList.remove('is-open');
      this.overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      this._clearResults();
      if (this.input) this.input.value = '';
    },

    _clearResults: function () {
      if (this.results) this.results.innerHTML = '';
      if (this.results) this.results.hidden = true;
    },

    _fetch: function (q) {
      var self = this;
      if (this.spinner) this.spinner.classList.add('is-active');

      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor';

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (self.spinner) self.spinner.classList.remove('is-active');
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          self._renderResults(products, q);
        })
        .catch(function () {
          if (self.spinner) self.spinner.classList.remove('is-active');
        });
    },

    _renderResults: function (products, q) {
      if (!this.results) return;
      if (!products.length) {
        this.results.innerHTML =
          '<div class="ikh-so-empty">No results for <strong>"' + q + '"</strong> &mdash; <a href="/search?type=product&q=' + encodeURIComponent(q) + '">browse all</a></div>';
        this.results.hidden = false;
        return;
      }
      var html = '<div class="ikh-so-results__list">';
      products.forEach(function (p) {
        /* featured_image is {url, alt} object in suggest API, or null */
        var imgUrl = p.featured_image && p.featured_image.url
          ? p.featured_image.url
          : (typeof p.featured_image === 'string' ? p.featured_image : null);
        /* Resize via Shopify CDN: append _56x56 before query string */
        if (imgUrl) imgUrl = imgUrl.replace(/(\.\w{3,4})(\?.*)?$/, '_120x120$1');
        var img = imgUrl
          ? '<img class="ikh-so-result__img" src="' + imgUrl + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" width="56" height="56" loading="lazy">'
          : '<div class="ikh-so-result__img ikh-so-result__img--ph"></div>';
        /* price is a decimal string like "34.00" — multiply by 100 for money() */
        var priceVal = p.price ? parseFloat(p.price) * 100 : 0;
        var price = priceVal ? '<span class="ikh-so-result__price">' + money(priceVal) + '</span>' : '';
        html += (
          '<a class="ikh-so-result" href="' + p.url + '">' +
            img +
            '<div class="ikh-so-result__info">' +
              '<span class="ikh-so-result__title">' + (p.title || '') + '</span>' +
              price +
            '</div>' +
          '</a>'
        );
      });
      html += '</div>';
      html += '<a class="ikh-so-results__all" href="/search?type=product&q=' + encodeURIComponent(q) + '">See all results for &ldquo;' + q + '&rdquo; &rarr;</a>';
      this.results.innerHTML = html;
      this.results.hidden = false;
    }
  };

  /* ── Scroll: header shadow ────────────────────────────── */
  var ScrollFX = {
    init: function () {
      var hdr = document.getElementById('ikh-hdr');
      if (!hdr) return;
      window.addEventListener('scroll', function () {
        hdr.classList.toggle('is-scrolled', window.scrollY > 8);
      }, { passive: true });
    }
  };

  /* ── Sticky ATC v2 ──────────────────────────────────── */
  var SATC = {
    variants: [],
    sel: {},
    optCount: 0,

    init: function () {
      var bar = document.getElementById('ikh2-bar');
      if (!bar) return;

      /* Load variants */
      var vEl = document.getElementById('ikh2-variants');
      if (vEl) {
        try { this.variants = JSON.parse(vEl.textContent); } catch (e) {}
      }
      this.optCount = (this.variants.length > 0 && this.variants[0].options)
        ? this.variants[0].options.length : 0;

      /* Show bar when main ATC scrolls out of view */
      var mainAtc = document.getElementById('ikh-atc-btn')
        || document.querySelector('.ikh-b-atc');
      if (!mainAtc) {
        setTimeout(function () { SATC.init(); }, 600);
        return;
      }
      var obs = new IntersectionObserver(function (entries) {
        if (bar.getAttribute('aria-hidden') !== 'true') {
          bar.classList.toggle('ikh2-on', !entries[0].isIntersecting);
        }
      }, { threshold: 0 });
      obs.observe(mainAtc);

      /* Auto-select first color dot */
      var firstDot = document.querySelector('.ikh2-sheet__dot');
      if (firstDot) {
        firstDot.classList.add('ikh2-on');
        this.sel[parseInt(firstDot.dataset.opt, 10)] = firstDot.dataset.val;
        var nameEl = document.getElementById('ikh2-color-name');
        if (nameEl) nameEl.textContent = firstDot.dataset.val;
      }
      this.refreshBtn();

      /* Open sheet */
      var barBtn = document.getElementById('ikh2-bar-btn');
      if (barBtn) barBtn.addEventListener('click', function () { SATC.openSheet(); });

      /* Close sheet */
      var xBtn = document.getElementById('ikh2-sheet-x');
      var overlay = document.getElementById('ikh2-overlay');
      if (xBtn) xBtn.addEventListener('click', function () { SATC.closeSheet(); });
      if (overlay) overlay.addEventListener('click', function () { SATC.closeSheet(); });

      /* Dot picks (delegated) */
      document.addEventListener('click', function (e) {
        var dot = e.target.closest('.ikh2-sheet__dot');
        if (!dot) return;
        var optIdx = parseInt(dot.dataset.opt, 10);
        dot.closest('.ikh2-sheet__dots')
          .querySelectorAll('.ikh2-sheet__dot')
          .forEach(function (d) { d.classList.remove('ikh2-on'); });
        dot.classList.add('ikh2-on');
        SATC.sel[optIdx] = dot.dataset.val;
        var nameEl = document.getElementById('ikh2-color-name');
        if (nameEl) nameEl.textContent = dot.dataset.val;
        SATC.refreshBtn();
      });

      /* Pill picks (delegated) */
      document.addEventListener('click', function (e) {
        var pill = e.target.closest('.ikh2-sheet__pill');
        if (!pill) return;
        var optIdx = parseInt(pill.dataset.opt, 10);
        pill.closest('.ikh2-sheet__pills')
          .querySelectorAll('.ikh2-sheet__pill')
          .forEach(function (p) { p.classList.remove('ikh2-on'); });
        pill.classList.add('ikh2-on');
        SATC.sel[optIdx] = pill.dataset.val;
        SATC.refreshBtn();
      });

      /* ATC button in sheet */
      var atcBtn = document.getElementById('ikh2-atc');
      if (atcBtn) atcBtn.addEventListener('click', function () { SATC.addToCart(); });
    },

    openSheet: function () {
      var sh = document.getElementById('ikh2-sheet');
      if (!sh) return;
      sh.classList.add('ikh2-open');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          sh.classList.add('ikh2-slide');
        });
      });
    },

    closeSheet: function () {
      var sh = document.getElementById('ikh2-sheet');
      if (!sh) return;
      sh.classList.remove('ikh2-slide');
      setTimeout(function () { sh.classList.remove('ikh2-open'); }, 380);
    },

    refreshBtn: function () {
      var btn = document.getElementById('ikh2-atc');
      if (!btn) return;
      var ready = true;
      for (var i = 0; i < this.optCount; i++) {
        if (!this.sel[i]) { ready = false; break; }
      }
      btn.disabled = !ready;
      btn.textContent = ready ? 'Add to Cart' : 'Select a size';
    },

    findVariant: function () {
      var sel = this.sel;
      return this.variants.find(function (v) {
        return v.options && v.options.every(function (o, i) { return sel[i] === o; });
      }) || null;
    },

    addToCart: function () {
      var btn = document.getElementById('ikh2-atc');
      if (!btn || btn.disabled) return;
      var variant = this.findVariant();
      if (!variant) return;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = '✓ Added!';
        /* Close the sheet first so its overlay doesn't cover the cart drawer */
        SATC.closeSheet();
        setTimeout(function () {
          if (window.InkhausCart) window.InkhausCart.open();
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
        }, 420);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Try again';
      });
    }
  };

  /* ── Header offset sync ───────────────────────────────── */
  var HeaderOffsets = {
    ann: null,
    hdr: null,
    init: function () {
      this.ann = document.querySelector('.ikh-ann');
      this.hdr = document.getElementById('ikh-hdr');
      if (!this.ann) return;
      /* Sync immediately, then again once fonts/layout settle */
      this.sync();
      setTimeout(this.sync.bind(this), 100);
      setTimeout(this.sync.bind(this), 500);
      /* Re-sync on resize (orientation change, text reflow) */
      window.addEventListener('resize', debounce(this.sync.bind(this), 80), { passive: true });
      /* Observe actual size changes of the announcement bar */
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(debounce(this.sync.bind(this), 40)).observe(this.ann);
      }
    },
    sync: function () {
      var ann = this.ann;
      var hdr = this.hdr;
      if (!ann) return;
      var annH = ann.getBoundingClientRect().height || ann.offsetHeight;
      var hdrH = hdr ? (hdr.getBoundingClientRect().height || hdr.offsetHeight) : (window.innerWidth <= 900 ? 56 : 68);
      /* Round up to avoid sub-pixel gaps */
      annH = Math.ceil(annH);
      hdrH = Math.ceil(hdrH);
      var offset = annH + hdrH;
      /* Update CSS variables — every element using var(--ikh-offset) updates instantly */
      var root = document.documentElement;
      root.style.setProperty('--ikh-announce-h', annH + 'px');
      root.style.setProperty('--ikh-header-h',   hdrH + 'px');
      root.style.setProperty('--ikh-offset',      offset + 'px');
      /* Explicitly position header below announcement bar */
      if (hdr) hdr.style.top = annH + 'px';
      /* Push main content so hero image starts exactly at the header's bottom edge */
      var main = document.getElementById('MainContent') ||
                 document.querySelector('main[role="main"]') ||
                 document.querySelector('.ikh-main');
      if (main) {
        main.style.setProperty('padding-top', offset + 'px', 'important');
      }
      /* Reposition search overlay and mobile nav */
      var overlay = document.querySelector('.ikh-search-overlay');
      if (overlay) overlay.style.top = offset + 'px';
      var mobileNav = document.getElementById('ikh-mobile-nav');
      if (mobileNav) mobileNav.style.top = offset + 'px';
    }
  };

  function debounce(fn, ms) {
    var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  /* ── Init ─────────────────────────────────────────────── */
  function init() {
    CartDrawer.init();
    AddToCart.init();
    Search.init();
    ScrollFX.init();
    SATC.init();
    HeaderOffsets.init();

    /* Expose globally so other section scripts can open the drawer */
    window.InkhausCart = {
      open:    function ()       { CartDrawer.open(); },
      close:   function ()       { CartDrawer.close(); },
      refresh: function ()       { CartAPI.get().then(function (c) { updateCartBadge(c.item_count); }); },
      add:     function (id, qty) { return CartAPI.add(id, qty); }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();


/* ==INKHAUS_VIBES== injected fix - replaces placeholder tiles with real images */
(function(){
  var CDN = 'https://cdn.shopify.com/s/files/1/0754/6860/3446/t/3/assets/';
  var MAP = {
    'Nurses':    'vibe-nurses.png',
    'Healthcare':'vibe-nurses.png',
    'Dog':       'vibe-dog-moms.png',
    'Pet':       'vibe-dog-moms.png',
    'Gym':       'vibe-gym.png',
    'Fitness':   'vibe-gym.png',
    'Dark':      'vibe-dark-humor.png',
    'Humor':     'vibe-dark-humor.png',
    'Festival':  'vibe-festival.png',
    'Nightlife': 'vibe-festival.png',
    'Custom':    'vibe-custom-tees.png',
    'Tee':       'vibe-custom-tees.png'
  };
  var FALLBACK = ['vibe-nurses.png','vibe-dog-moms.png','vibe-gym.png',
                  'vibe-dark-humor.png','vibe-festival.png','vibe-custom-tees.png'];

  function fixVibes() {
    var tiles = document.querySelectorAll('.ikcat__tile');
    if (!tiles.length) return;
    tiles.forEach(function(tile, idx) {
      if (tile.querySelector('.ikcat__img')) return; // already has image
      var ph = tile.querySelector('.ikcat__placeholder');
      var text = (tile.getAttribute('aria-label') || '') + ' ' +
                 (tile.querySelector('.ikcat__label') ? tile.querySelector('.ikcat__label').textContent : '');
      var file = FALLBACK[idx % FALLBACK.length];
      for (var k in MAP) { if (text.indexOf(k) > -1) { file = MAP[k]; break; } }
      var img = document.createElement('img');
      img.className = 'ikcat__img';
      img.src = CDN + file;
      img.alt = text.trim();
      img.loading = idx < 3 ? 'eager' : 'lazy';
      img.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;';
      if (ph) ph.parentNode.replaceChild(img, ph);
      else tile.insertBefore(img, tile.firstChild);
    });
  }

  function fixHero() {
    var hero = document.querySelector('.ikh-hero');
    if (!hero || hero.querySelector('.ikh-hero__bg')) return;
    var img = document.createElement('img');
    img.className = 'ikh-hero__bg';
    img.src = CDN + 'hero-bg.png';
    img.alt = 'INKHAUS hero';
    img.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:0;';
    hero.insertBefore(img, hero.firstChild);
  }

  function run() { fixVibes(); fixHero(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
/* ==END_INKHAUS_VIBES== */